import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AppSettingContext = createContext();

export const useAppSetting = () => {
  const context = useContext(AppSettingContext);
  if (!context) {
    throw new Error('useAppSetting must be used within AppSettingProvider');
  }
  return context;
};

export const AppSettingProvider = ({ children }) => {
  const [appSetting, setAppSetting] = useState({
    nama_aplikasi: 'Aplikasi AI',
    logo_image: null,
    background_image: null,
  });

  const fetchAppSetting = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/auth/setting`, {
        withCredentials: true,
      });

      const settings = res.data.settings;
      if (settings) {
        setAppSetting({
          nama_aplikasi: settings.nama_aplikasi || 'Aplikasi AI',
          logo_image: settings.logo_image
            ? `${process.env.REACT_APP_API_BASE_URL}/${settings.logo_image}`
            : null,
          background_image: settings.background_image
            ? `${process.env.REACT_APP_API_BASE_URL}/${settings.background_image}`
            : null,
        });
      }
    } catch (err) {
      console.warn('Gagal ambil setting, gunakan default', err);
    }
  };

  useEffect(() => {
    fetchAppSetting();
  }, []);

  return (
    <AppSettingContext.Provider value={{ appSetting, setAppSetting, refreshSetting: fetchAppSetting }}>
      {children}
    </AppSettingContext.Provider>
  );
};